// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"71dce437","55":"269c12aa","140":"bede6a2f","144":"5430498a","171":"e0f150de","363":"6126a671","453":"1a1423fb","466":"f536528e","599":"92822cf1","780":"198f28cf","968":"7171f145"}[chunkId] + ".chunk.js";
};